<template>
  <div class="configurator_holder">
    <slot></slot>
    
   <div class="configurator">

    <div transition="fadeimg" v-show="bonus" class="configurator_bonus">
      <img  v-if="size === 'mobile' "  v-bind:src="bonusOption.mobileImage" alt="">
      <img  v-else  v-bind:src="bonusOption.image" alt="">
    </div>
    <div class="configurator_cabinets">
      <img 
      v-for=" img in images" 
      transition="fadeimg" 
      v-if="size === 'desktop' " 
      v-show="cabinetcolor === img.cabinet.toLowerCase() && fabricsuite === img.fabric.toLowerCase()"  
      class="configurator_inner" 
      v-bind:src="img.path" alt="">

      <img 
      v-for=" img in images" 
      transition="fadeimg" 
      v-if="size === 'mobile' " 
      v-show="cabinetcolor === img.cabinet.toLowerCase() && fabricsuite === img.fabric.toLowerCase()"  
      class="configurator_inner" 
      v-bind:src="img.mobilePath" alt="">

     <!--  <img 
      v-for=" option in cabinetOptions" 
      transition="fadeimg" 
      v-if="size === 'mobile' " 
      v-show=" cabinetcolor === option.title.toLowerCase() "  
      class="configurator_inner" 
      v-bind:src="option.mobileImage" alt=""> -->
     <!--  <img transition="fadeimg" v-show=" cabinetcolor === 'cordovan' " class="configurator_inner" v-bind:src="cordovanimg" alt="">
      <img transition="fadeimg" v-show=" cabinetcolor === 'alderwood' " class="configurator_inner" v-bind:src="alderwoodimg" alt=""> -->
    </div> <!-- end .configurator_cabinets -->
    <div class="configurator_carpet">
     <!--  <img v-for=" option in fabricOptions" transition="fadeimg"   class="configurator_inner" v-bind:src="option.image"  alt=""> -->
   <!--    <img transition="fadeimg"  v-show=" fabricsuite === 2 " class="configurator_inner" v-bind:src="zestimg"  alt="">     -->
    <!--   <img v-if="size === 'desktop' && option.image !== '' " v-for=" option in fabricOptions" transition="fadeimg" v-show=" fabricsuite === option.title.toLowerCase() "  class="configurator_inner" v-bind:src="option.image" alt="">
      <img v-if="size === 'mobile' && option.mobileImage !== '' " v-for=" option in fabricOptions" transition="fadeimg" v-show=" fabricsuite === option.title.toLowerCase() "  class="configurator_inner" v-bind:src="option.mobileImage" alt=""> -->
    </div> <!-- end .configurator_carpet -->
  </div> <!-- end .configurator -->
  <img class="img_position_setter" v-bind:src="base">

  </div>
</template>
<script>
export default {
  props: [ 
    'base', 
    'size', 
    'cabinetOptions', 
    'fabricOptions', 
    'cabinetcolor', 
    'fabricsuite', 
    'chestnutimg', 
    'cordovanimg', 
    'alderwoodimg', 
    'alomndimg', 
    'zestimg', 
    'baseimg', 
    'bonus', 
    'bonusOptions', 
    'room',
    'images'
  ],
  computed: {
    bonusOption () {
      console.log()
      return this.bonusOptions.filter( item => {
        return item.room === this.room 
      })[0].features[0]
    }
  },
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      
    }
  },
  ready () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 /* always present */
 .fadeimg-transition {
   opacity: 1;
   transition: 0.5s ease-out;
 }
 /* .fadeimg-enter defines the starting state for entering */
 /* .fadeimg-leave defines the ending state for leaving */
 .fadeimg-enter, .fadeimg-leave {
   opacity: 0;
 }
 .configurator_bonus{
  position: absolute;
  z-index: 100;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
 }
.configurator_bonus img {
  width: 100%;
}  

</style>



/** WEBPACK FOOTER **
 ** flatConfigurator.vue?5de34daa
 **/